import React, { FC } from 'react'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'

interface ConfirmationModalProps {
    show: boolean
    title: string
    message: string
    confirmText: string
    cancelText?: string
    onConfirm: () => void
    onClose: () => void
}

const ConfirmationModal: FC<ConfirmationModalProps> = ({
    show,
    title,
    message,
    confirmText,
    cancelText = 'Cancel',
    onConfirm,
    onClose,
}) => {
    return (
        <Modal
            show={show}
            onHide={onClose}
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title className='h5'>
                    {title}
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>{message}</Modal.Body>

            <Modal.Footer className='justify-content-end border-0 pt-0'>
                <Button
                    variant='secondary'
                    onClick={onClose}
                >
                    {cancelText}
                </Button>

                <Button
                    variant='primary'
                    onClick={onConfirm}
                >
                    {confirmText}
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default ConfirmationModal